import enableDisableUserReducerFactory from './enableDisableUserReducerFactory';
import * as types from '../../actions/types';

export default enableDisableUserReducerFactory(
  types.CONFIRM_DISABLE_USER, types.CANCEL_DISABLE_USER,
  types.DISABLE_USER_PENDING, types.DISABLE_USER_FULFILLED, types.DISABLE_USER_REJECTED
);



// WEBPACK FOOTER //
// ./app/features/users/reducers/modals/disableUser.js